var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttons-cover" }, [
    _c(
      "div",
      { staticClass: "default-button selectedPlanButton" },
      [
        _vm.value === "monthly"
          ? [_vm._v(" 1  " + _vm._s(_vm.$t("billing.monthly")) + " ")]
          : _vm._e(),
        _vm._v(" "),
        _vm.value === "monthly-3"
          ? [
              _vm._v("  " + _vm._s(_vm.$t("billing.threeMonthly")) + " "),
              _c("span", { staticClass: "free-months" }, [
                _vm._v("(10% " + _vm._s(_vm.$t("billing.discount")) + ")"),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.value === "monthly-6"
          ? [
              _vm._v(" " + _vm._s(_vm.$t("billing.sixMonthly")) + " "),
              _c("span", { staticClass: "free-months" }, [
                _vm._v("(20% " + _vm._s(_vm.$t("billing.discount")) + ")"),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.value === "annual"
          ? [
              _vm._v(" " + _vm._s(_vm.$t("billing.yearly")) + " "),
              _c("span", { staticClass: "free-months" }, [
                _vm._v("(30% " + _vm._s(_vm.$t("billing.discount")) + ")"),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.value === "annual-2"
          ? [
              _vm._v(" " + _vm._s(_vm.$t("billing.twoYearly")) + " "),
              _c("span", { staticClass: "free-months" }, [
                _vm._v("(40% " + _vm._s(_vm.$t("billing.discount")) + ")"),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "more_periodly" }, [
      _c(
        "div",
        {
          staticClass: "material-icons",
          on: {
            click: function ($event) {
              _vm.dropdown = !_vm.dropdown
            },
          },
        },
        [_vm._v("change_circle")]
      ),
      _vm._v(" "),
      _vm.dropdown
        ? _c(
            "div",
            { ref: "dropdown", staticClass: "more_periodly-dropdown" },
            [
              _c(
                "div",
                {
                  staticClass: "default-button",
                  class: { selectedPlanButton: _vm.value == "monthly" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedPlan("monthly")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("billing.monthly")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "default-button",
                  class: { selectedPlanButton: _vm.value == "monthly-3" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedPlan("monthly-3")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("billing.threeMonthly")) +
                      " "
                  ),
                  _c("span", { staticClass: "free-months" }, [
                    _vm._v("(10% " + _vm._s(_vm.$t("billing.discount")) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "default-button",
                  class: { selectedPlanButton: _vm.value == "monthly-6" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedPlan("monthly-6")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("billing.sixMonthly")) +
                      " "
                  ),
                  _c("span", { staticClass: "free-months" }, [
                    _vm._v("(20% " + _vm._s(_vm.$t("billing.discount")) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "default-button",
                  class: { selectedPlanButton: _vm.value == "annual" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedPlan("annual")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("billing.yearly")) +
                      " "
                  ),
                  _c("span", { staticClass: "free-months" }, [
                    _vm._v("(30% " + _vm._s(_vm.$t("billing.discount")) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "default-button",
                  class: { selectedPlanButton: _vm.value == "annual-2" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedPlan("annual-2")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("billing.twoYearly")) +
                      " "
                  ),
                  _c("span", { staticClass: "free-months" }, [
                    _vm._v("(40% " + _vm._s(_vm.$t("billing.discount")) + ")"),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }